import { Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { BsMegaphoneFill } from 'react-icons/bs';

import { useAuth } from '../../../../hooks/useAuth';
import { useMobileVersion } from '../../../../hooks/useMobileVersion';
import { Container, FloatingButton } from './styles';

declare global {
  interface Window {
    IssueWidget?: any;
    IssueWidgetAPI?: {
      open: () => void;
      close: () => void;
      toggle: () => void;
    };
  }
}

const WIDGET_VERSION = '1.1.0';

export const FeedbackButton = () => {
  const { user } = useAuth();
  const isMobileVersion = useMobileVersion();
  const [isWidgetReady, setIsWidgetReady] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    if (document.getElementById('issue-widget-script')) return;

    const script = document.createElement('script');
    script.id = 'issue-widget-script';
    script.src = `https://gestao.redhmam.com/widget/widget.js?v=${WIDGET_VERSION}`;

    script.onload = () => {
      // In SPAs, DOMContentLoaded already fired, so we need to manually instantiate
      const checkInterval = setInterval(() => {
        if (window.IssueWidget && typeof window.IssueWidget === 'function') {
          const widget = new window.IssueWidget({
            token: '37769020-f60f-4c9a-94f2-4cf044803866',
            hideButton: true,
            userMetadata: {
              email: user.email,
              name: user.name,
            },
          });
          widget.init();
          setIsWidgetReady(true);
          clearInterval(checkInterval);
        } else if (window.IssueWidgetAPI) {
          setIsWidgetReady(true);
          clearInterval(checkInterval);
        }
      }, 100);

      // Stop checking after 5 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 5000);
    };

    document.body.appendChild(script);
  }, [user?.id, user?.email, user?.name]);

  const openFeedbackWidget = () => {
    if (window.IssueWidgetAPI && window.IssueWidgetAPI.open) {
      window.IssueWidgetAPI.open();
    }
  };

  if (!isWidgetReady) return null;

  return (
    <Container $isMobileVersion={isMobileVersion}>
      <Tooltip
        title="Enviar feedback"
        placement="left"
        mouseEnterDelay={0.5}
      >
        <FloatingButton
          onClick={openFeedbackWidget}
          icon={<BsMegaphoneFill />}
          aria-label="Enviar feedback"
        />
      </Tooltip>
    </Container>
  );
};
